module.exports = __webpack_public_path__ + "img/cn-pro-3-t.ca233aee.png";